import { RECIPIENTS_PATH, RETAIL_PATH } from '../root'

export const APPROVED_RECIPIENTS = 'approved'
export const PENDING_RECIPIENTS = 'pending'
export const RECIPENTS_FULL_PATH = `${RETAIL_PATH}${RECIPIENTS_PATH}`
export const NEW_BENEFICIARY = 'new-beneficiary'
export const NEW_BENEFICIARY_FULL_PATH = `${RECIPENTS_FULL_PATH}/${NEW_BENEFICIARY}`
